export default __webpack_public_path__ + "static/media/pharah.396a9410.webp";